/*Generated from the `:::slide{key="2f5c0504-963f-441c-adc0-c95449b93757" slug="pinyin-initials"}` (simplified/001/011/干.mdx), `:::slide{key="9f464394-c7c1-444d-b087-0e46d3783184" slug="multiple-pronunciations"}` (simplified/001/011/干.mdx) directives, merged because they share one anchor. Edit the lesson or level file.*/
import {useMDXComponents} from "@bacons/mdx";
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function _createMdxContent(props) {
  const components = {
    ...useMDXComponents(),
    ...props.components
  };
  const {SlidePageBlock, ...html} = components;
  if (!SlidePageBlock) _missingMdxReference("SlidePageBlock", true);
  if (!html) _missingMdxReference("html", false);
  if (!html.blockquote) _missingMdxReference("html.blockquote", true);
  if (!html.em) _missingMdxReference("html.em", true);
  if (!html.p) _missingMdxReference("html.p", true);
  if (!html.strong) _missingMdxReference("html.strong", true);
  return _jsxs(_Fragment, {
    children: [_jsx(SlidePageBlock, {
      block: "0",
      section: "0",
      kind: "p",
      count: "6",
      children: _jsxs(html.p, {
        children: ["Unlike ", _jsx(html.em, {
          children: "àn",
          components: html
        }), ", the pinyin ", _jsx(html.em, {
          children: "gàn",
          components: html
        }), " has the consonant part ", _jsx(html.em, {
          children: "g",
          components: html
        }), " known as the ", _jsx(html.strong, {
          children: "initial.",
          components: html
        })]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "1",
      section: "0",
      kind: "p",
      count: "6",
      children: _jsxs(html.p, {
        children: ["The vowel-based ending ", _jsx(html.em, {
          children: "-an",
          components: html
        }), " is known as the ", _jsx(html.strong, {
          children: "final",
          components: html
        }), "."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "2",
      section: "0",
      kind: "p",
      count: "6",
      children: _jsxs(html.p, {
        children: ["All pinyins are made from a (possibly empty) ", _jsx(html.strong, {
          children: "initial",
          components: html
        }), " and a ", _jsx(html.strong, {
          children: "final",
          components: html
        }), "."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "3",
      section: "0",
      kind: "blockquote",
      count: "6",
      children: _jsx(html.blockquote, {
        children: _jsxs(html.p, {
          children: ["The syllable ", _jsx(html.em, {
            children: "gan",
            components: html
          }), " roughly sounds like \"", _jsx(html.strong, {
            children: "gun",
            components: html
          }), "\"."]
        }),
        components: html
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "4",
      section: "1",
      kind: "p",
      count: "6",
      children: _jsxs(html.p, {
        children: ["干 is a ", _jsx(html.strong, {
          children: "polyphonic",
          components: html
        }), " character, which means it has multiple pronunciations with different meanings."]
      }),
      components: html
    }), _jsx(SlidePageBlock, {
      block: "5",
      section: "1",
      kind: "p",
      count: "6",
      children: _jsxs(html.p, {
        children: ["In the pinyin ", _jsx(html.em, {
          children: "gān",
          components: html
        }), ", the straight line above the \"a\" represents the ", _jsx(html.strong, {
          children: "high tone",
          components: html
        }), "."]
      }),
      components: html
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
